import FieldSet from '../../FieldSet';

import { ThemeName } from './ThemeName';

export class IdeaThemeFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [ThemeName];
  }

  get title() {
    return 'Themes';
  }
}
